import { keyBy } from "lodash";

import { Group } from "@livechat/design-system-icons";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

import { IGroupFilterItem } from "./group-filter";

const title = "Team";
export const groupFilterConfigMultiple: IFilterConfig = {
  title,
  icon: Group,
  mobileViewTitle: "Select teams",
  multiple: true,
  getFilterLabelValues: (
    filterValues: string[] | null,
    groups: IGroupFilterItem[],
    _: unknown,
    allGroups?: IGroupFilterItem[]
  ): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    const groupsMap = keyBy(groups, group => group.id);
    const allGroupsMap = allGroups ? keyBy(allGroups, group => group.id) : {};

    return filterValues.reduce((acc: IFilterLabelValue[], groupId): IFilterLabelValue[] => {
      if (groupId === "MY_TEAMS") {
        return [...acc, { key: "all_teams", label: "My teams" }];
      }

      if (groupsMap[groupId]) {
        return [...acc, { key: groupsMap[groupId].id, label: groupsMap[groupId].name ?? "" }];
      }

      const removedLabel = allGroupsMap[groupId] ? `${title} unavailable` : `${title} removed`;
      return [...acc, { key: groupId, label: removedLabel, invalid: true }];
    }, []);
  },
};
